import { FC } from 'react';
import { IonIcon } from '@ionic/react';
import { heart } from 'ionicons/icons';

// Empty-state shown in the list drawer when the Favorites filter is active but
// the user has not saved any EGMs to their favorites yet.
const FavoritesEmptyNotice: FC = () => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '24px',
      padding: '40px 24px 24px',
      textAlign: 'center',
    }}
  >
    <h2
      style={{
        width: '292px',
        maxWidth: '100%',
        margin: 0,
        color: '#FFF',
        textAlign: 'center',
        fontFamily: 'Heebo',
        fontSize: '30px',
        fontStyle: 'normal',
        fontWeight: 700,
        lineHeight: '100%',
        letterSpacing: '-0.6px',
      }}
    >
      Favorites is Empty
    </h2>

    <div
      style={{
        alignSelf: 'stretch',
        color: '#FFF',
        textAlign: 'center',
        fontFamily: 'Heebo',
        fontSize: '18px',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: 'normal',
        letterSpacing: '-0.54px',
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
      }}
    >
      <p style={{ margin: 0 }}>You currently have no Favorites.</p>
      <p style={{ margin: 0 }}>
        Adding your favorite games to Favorites is a quick and easy way to track your games away
        from the casino, compare their performance, and see them on the map. It can help make your
        casino visit more enjoyable.
      </p>
      <p style={{ margin: 0 }}>
        Just click the{' '}
        <IonIcon icon={heart} style={{ fontSize: '20px', verticalAlign: 'middle' }} />{' '}
        icon on any slot card or look for the “Add to Favorites” icon or action elsewhere in the
        app.
      </p>
    </div>
  </div>
);

export default FavoritesEmptyNotice;
